import { Flex, FlexProps } from 'component-library/components/layout/Flex';
import { Body } from 'component-library/components/typography/Body';
import { Subheading } from 'component-library/components/typography/Subheading';
import React, { FC, ReactNode } from 'react';

export interface ValuePropItemProps extends FlexProps {
  heading?: string;
  body: string;
  icon: ReactNode;
}

export const ValuePropItem: FC<ValuePropItemProps> = ({
  heading,
  body,
  icon,
  ...rest
}) => (
  <Flex column {...rest}>
    {icon}
    {heading && (
      <Subheading variant={2} marginBottom={12} marginTop={32}>
        {heading}
      </Subheading>
    )}
    <Body variant={3} marginTop={12}>
      {body}
    </Body>
  </Flex>
);
